<ul
  [attr.id]="mElementId()"
  [ngStyle]="mElementStyles()"
  [ngClass]="mElementStyleClasses()"
  class="m-flex m-flex-column m-gap:2 m-text-body:5 m-padding:0 m-margin:0 m-width:full"
>
  @for (hint of orderedHints(); track hint) {
    <li class="m-padding:0 m-margin:0 m-width:full">
      <myui-hint [level]="hint.level" [text]="hint.text">
        @if (itemTemplate()) {
          <ng-template [mTemplate]="'text'">
            <ng-container
              *ngTemplateOutlet="
                itemTemplate().template;
                context: _getItemContext(hint)
              "
            />
          </ng-template>
        }
      </myui-hint>
    </li>
  }
</ul>
